export function LegalHeader({
  title,
  subtitle,
  maxWidthClassName = "max-w-6xl",
}: {
  title: string;
  subtitle: string;
  maxWidthClassName?: string;
}) {
  return (
    <div className="relative overflow-hidden bg-[#091661] py-16 text-white">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 80% at 80% 20%, rgba(255,255,255,.08), transparent 70%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage: "url('/footer/footer-pattern.png')",
          backgroundPosition: "bottom center",
          backgroundRepeat: "repeat-x",
          backgroundSize: "auto 75%",
        }}
      />
      <div className={`relative z-10 ${maxWidthClassName} mx-auto px-6`}>
        <h1
          className="text-4xl lg:text-5xl font-bold mb-4"
          style={{ color: "white" }}
        >
          {title}
        </h1>
        <p className="text-xl text-white/80">{subtitle}</p>
      </div>
    </div>
  );
}
